module.exports = __webpack_public_path__ + "img/logo-lan-putih.6de14fd1.png";